import { render, staticRenderFns } from "./TileDisplacement.vue?vue&type=template&id=47de607e&scoped=true"
import script from "./TileDisplacement.vue?vue&type=script&lang=ts"
export * from "./TileDisplacement.vue?vue&type=script&lang=ts"
import style0 from "./TileDisplacement.vue?vue&type=style&index=0&id=47de607e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47de607e",
  null
  
)

export default component.exports